var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'v-radio-group',
    _vm.showError && (!!_vm.error || !!_vm.errorSlot) && 'v-radio-group--error'
  ]},[_c('EventListener',{on:{"radio-invalid":_vm.onInvalid,"radio-change":_vm.onChange}},[_vm._t("default")],2),_c('div',{class:['v-radio-group__helper']},[_vm._v(" "+_vm._s(_vm.showError ? _vm.error || _vm.errorSlot : _vm.description)+" ")]),(!_vm.mounted)?_c('div',{ref:"error"},[_vm._t("error")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }